module.exports = __webpack_public_path__ + "assets/Other selected.32fa08dee1c411a2586449751f87d7c2.png";